export default __webpack_public_path__ + "static/media/site_stats.2f26ad97.svg";